var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-select',{attrs:{"dense":"","outlined":"","items":_vm.selectGroups,"hide-details":"","value":_vm.selectedGroup},on:{"change":_vm.setGroup}})}
var staticRenderFns = []

export { render, staticRenderFns }